
const config: IConfig = {
  serve: 'https://c4rap2.ttshop.io/delos',
  keys: ['some secret hurr'],
  session: {
    key: 'koa:sess',
  },
}

export default config
